<app-dialog headerText="User Information" [headerGlyph]="['far', 'circle-user']" [body]="body" [showSaveButton]="false" cancelText="Close" [showTopCancelButton]="false"></app-dialog>

<ng-template #body>
    <div>Name: {{name}}</div>
    <div>ID: {{email}}</div>
    <div>E-mail: {{email}}</div>
    <div>Logged In At: {{idp}}</div>
</ng-template>

